import React, { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { i18n as I18n, withTranslation } from '../utils/i18n';

// Context
import { AuthContext } from '../state/auth';

// Components
import Page from '../components/page';
import LoginActionPanel from '../components/loginActionPanel';
import LoginForm from '../components/forms/login';

const SignInPage = () => {
  const { actions, errorMessage } = useContext(AuthContext);
  const router = useRouter();

  const signIn = async (
    { email, password },
    { setSubmitting = () => {} } = {}
  ) => {
    await actions.signIn(email, password);
    setSubmitting(false);
  };

  useEffect(() => {
    const returnToPage = router.query.returnTo;

    if (returnToPage && I18n.exists(`navigation.${returnToPage}.url`)) {
      actions.setReturnUrl(I18n.t(`navigation.${returnToPage}.url`));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Page
      title={I18n.t('headers.sign_in_page.title')}
      description={I18n.t('headers.sign_in_page.description')}
    >
      <LoginActionPanel
        heading={I18n.t('sign_in.header')}
        showBackToLoginLink={false}
      >
        {errorMessage && <p className="login__error">{errorMessage}</p>}
        <LoginForm onSubmit={signIn} />
      </LoginActionPanel>
    </Page>
  );
};

SignInPage.getInitialProps = async () => ({
  namespacesRequired: ['common'],
});

export default withTranslation('common')(SignInPage);
